import Vue from "vue";
import ja from "@/i18n/ja";
import VueI18n from "vue-i18n";
Vue.use(VueI18n);
// export default { ja };

const trans18next = new VueI18n({
  locale: "ja",
  messages: {
    ja: ja,
  },
});

export default trans18next;
